import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import type { Integration } from "@prescreen/lib/types"
import { IntegrationCardActionsMenu } from "@/components/IntegrationCardActionsMenu"

interface IntegrationCardProps {
  integration: Integration
  onEdit?: (integration: Integration) => void
  onManageSecrets?: (integration: Integration) => void
  onDelete?: (integration: Integration) => void
  isDeleting?: boolean
}

export default function IntegrationCard({
  integration,
  onEdit,
  onManageSecrets,
  onDelete,
  isDeleting,
}: IntegrationCardProps) {
  const activeSecrets =
    integration.oauthSecrets?.filter((s) => s.isActive !== false).length ?? 0

  return (
    <Card className="transition-shadow hover:shadow-md">
      <CardHeader>
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <CardTitle className="text-lg">{integration.name}</CardTitle>
            {integration.description ? (
              <CardDescription className="mt-1">{integration.description}</CardDescription>
            ) : null}
          </div>
          <IntegrationCardActionsMenu
            integration={integration}
            onEdit={onEdit}
            onManageSecrets={onManageSecrets}
            onDelete={onDelete}
            isDeleting={isDeleting}
          />
        </div>
      </CardHeader>
      <CardContent className="space-y-3">
        <div>
          <h4 className="mb-2 text-sm font-medium text-gray-700">Client</h4>
          <div className="text-sm">
            <span className="text-gray-500">Client ID:</span>
            <code className="ml-2 rounded bg-gray-100 px-2 py-1 text-xs">{integration.clientId}</code>
          </div>
        </div>
        <div className="rounded-lg border border-muted bg-muted/30 px-3 py-2 text-sm">
          <span className="font-medium text-foreground">{activeSecrets}</span>
          <span className="text-muted-foreground">
            {" "}
            active secret{activeSecrets === 1 ? "" : "s"}
          </span>
        </div>
      </CardContent>
    </Card>
  )
}
